import BigToggle from "../../../../helperComponents/BigToggle";

const DAY_OPTIONS = [
  { value: "MON", label: "Lundi" },
  { value: "TUE", label: "Mardi" },
  { value: "WED", label: "Mercredi" },
  { value: "THU", label: "Jeudi" },
  { value: "FRI", label: "Vendredi" },
  { value: "SAT", label: "Samedi" },
  { value: "SUN", label: "Dimanche" },
];

export default function ScheduleDayPicker({ value, onChange, label }) {
  if (!value) value = [];

  return (
    <BigToggle
      title={label}
      options={DAY_OPTIONS.map((item) => getItem(item))}
    ></BigToggle>
  );

  function getItem(item) {
    return {
      onClick: () => {
        let newItems = [...value];

        if (newItems.includes(item.value)) {
          let index = newItems.indexOf(item.value);
          newItems.splice(index, 1);
        } else {
          newItems.push(item.value);
        }

        onChange(newItems);
      },
      isSelected: value.includes(item.value),
      label: item.label,
    };
  }
}
